module.exports = __webpack_public_path__ + "static/media/sunrise.c620fba4.svg";